export default "__VITE_ASSET__tvbTGJ1g__";